import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import PaymentsPage from "./paymentsPage";
import axios from "axios";
import Header from "../../Layout/authHeader/index";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import headerScripts from "../../Layout/Header/headerScripts";
import { he } from "date-fns/esm/locale";

const AUTH_UTIL_UTL = process.env.REACT_APP_AUTH_UTIL_URL;
const notifyError = (msg) =>
  toast.error(msg, { position: "top-right", autoClose: 3000 });

function PaymentsRoutes(props) {
  var path = props.match.path;
  const axiosInstance = axios.create({ baseURL: AUTH_UTIL_UTL });
  const [headerData, setHeaderData] = useState();

  const fetchHeaderData = async () => {
    try {
      const headerData = await Promise.all([axiosInstance.get(`header/`)]);
      setHeaderData(headerData[0].data);
    } catch (err) {
      notifyError("Oops something went wrong");
    }
  };

  useEffect(() => {
    fetchHeaderData();
  }, []);

  return (
    <>
      {headerData ? (
        <Header
          headerData={headerData}
          headerScripts={headerScripts}
          headerSticky={true}
        />
      ) : null}
      <div className="CrmRoutes">
        <Switch>
          <Route
            path={`${path}/:course_slug/:batchID?`}
            component={PaymentsPage}
          ></Route>
        </Switch>
      </div>
    </>
  );
}

export default PaymentsRoutes;
